/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import FilterListIcon from '@material-ui/icons/FilterList';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {useMediaQuery} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import ProductBanner from '../../assets/images/product-banner.png';
import {makeStyles} from '@material-ui/core/styles';
import ProductList from '../../components/ProductList';
import {searchClient} from '../../config';
// noinspection ES6CheckImport
import {Configure, InstantSearch} from 'react-instantsearch-dom';
import {createURL} from '../../modules/utils';
import {useLocation, useRouteMatch} from 'react-router-dom';
import AlgoliaCategories from '../AlgoliaCategories';
import AlgoliaBrands from '../AlgoliaBrands';
import {useDispatch, useSelector} from 'react-redux';
import {SELECTOR_SEARCH_FILTERS, SELECTOR_SEARCH_PAGE} from '../../redux/selectors/search';
import {setSearchFilters, setSearchPage} from '../../redux/actions';
import Pagination from './Pagination';
import ClearFilterBottom from './ClearFilterBottom';
import Helmet from '../../components/Helmet';
import api from '../../services/api';
import AlgoliaDiscounts from '../AlgoliaDiscounts';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 380,
    width: '100%',
    backgroundImage: `url(${ProductBanner})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    objectFit: 'cover',
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      height: 240,
      marginBottom: theme.spacing(3),
    },
  },
  content: {
    width: '90%',
    maxWidth: 450,
  },
  title: {
    fontWeight: 700,
    fontSize: '1.5rem',
    marginBottom: theme.spacing(1),
    display: 'flex',
  },
  titleIcon: {
    fontWeight: 700,
    fontSize: '1.5rem',
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: '8px',
  },
  detail: {
    marginBottom: theme.spacing(12),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(3),
    },
  },
  filtersItem: {
    paddingTop: 0,
    paddingBottom: 0,
    maxHeight: 28,
  },
  filtersTitle: {
    fontWeight: 600,
    fontSize: '.8rem',
    color: theme.palette.text.primary,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
  },
  filtersText: {
    fontWeight: 300,
    textTransform: 'capitalize',
  },
  filtersIcon: {
    minWidth: 'auto',
    fontSize: '.81rem',
  },
  checkIcon: {
    backgroundColor: '#E3E3E3',
    width: '.6em',
    height: '.6em',
    margin: '.1em',
  },
  checkActiveIcon: {
    width: '.8em',
    height: '.8em',
  },
  hiddenFilter: {
    display: 'none',
  },
  showFilter: {
    opacity: '1',
    display: 'block',
    transition: 'opacity 0.5s ease',
  },
  nested: {
    width: '100%',
  },
}));

const Search = () => {
  const page = useSelector(SELECTOR_SEARCH_PAGE);
  const filters = useSelector(SELECTOR_SEARCH_FILTERS);

  const [queryState, setQueryState] = useState('');
  const [categoryName, setCategoryName] = useState(null);

  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const matchCategory = useRouteMatch('/c-:c_id-:c_name');
  const [open, setOpen] = useState(false);

  const isMobil = useMediaQuery('(max-width:575px)');

  useEffect(() => {
    setOpen(!isMobil);
  }, [isMobil]);

  const handleClick = () => {
    console.log('Cambio de filtro:', !open);
    setOpen(!open);
  };

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(location.search);
    if (urlSearchParams.has('configure[page]')) {
      const searchPage = Number(urlSearchParams.get('configure[page]'));
      if (searchPage !== page) dispatch(setSearchPage(searchPage));
    }
  }, [location.search]);

  function onSearchStateChange(updatedSearchState) {
    const f = removeEmptyOrNull(updatedSearchState);
    if (Object.keys(f).length) {
      try {
        delete f.configure.query;
        delete f.page;
      } catch (e) {}
      dispatch(setSearchFilters(f));
    }
  }

  function removeEmptyOrNull(obj) {
    const _obj = JSON.parse(JSON.stringify(obj));
    Object.keys(_obj).forEach((k) => {
      if (!_obj[k] || _obj[k] === '') {
        delete _obj[k];
      }

      if (typeof _obj[k] === 'object') {
        removeEmptyOrNull(_obj[k]);
      }
    });
    return _obj;
  }

  useEffect(() => {
    if (location.search) {
      const urlSearchParams = new URLSearchParams(location.search);
      if (urlSearchParams.has('configure[query]')) {
        setQueryState(urlSearchParams.get('configure[query]'));
      } else {
        setQueryState('');
      }
    }
  }, [location.search]);

  useEffect(() => {
    if (matchCategory) {
      api.categories.get(matchCategory.params.c_id).then((it) => {
        setCategoryName(it.name);
      });
    }
  }, [matchCategory]);

  return (
    <div style={{paddingTop: 10}}>
      <InstantSearch
        indexName="products"
        searchState={{...filters, page}}
        onSearchStateChange={onSearchStateChange}
        createURL={createURL}
        searchClient={searchClient}
      >
        {matchCategory ? (
          categoryName ? (
            <Helmet
              title={categoryName}
              description={categoryName}
              canonical={location.pathname}
              og={{
                url: window.location.href,
                title: 'Estrategias LTDA',
                description: categoryName,
                image: '',
              }}
            />
          ) : (
            ''
          )
        ) : (
          <Helmet
            title={'Buscador'}
            description={''}
            og={{
              url: window.location.href,
              title: 'Estrategias LTDA',
              description: '',
              image: '',
            }}
          />
        )}
        <Container className={classes.detail} maxWidth="xl">
          <Grid container spacing={3}>
            <Grid item xs={12} md={3} lg={2}>
              <List component="nav" aria-labelledby="nested-list-subheader">
                <ListItem button onClick={handleClick}>
                  <ListItemIcon>
                    <FilterListIcon />
                  </ListItemIcon>
                  <ListItemText primary="Filtros" />
                  {open ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={open} timeout="auto" unmountOnExit className={classes.nested}>
                  <List component="div" disablePadding autoFocus={false}>
                    <ListItem>
                      <AlgoliaDiscounts
                        className={classes.nested}
                        attribute="discount_percentage"
                        items={[
                          {label: 'Hasta 10%', end: 10},
                          {label: '10% a 20%', start: 10, end: 20},
                          {label: '20% a 40%', start: 20, end: 40},
                          {label: 'Desde 50%', start: 50},
                          {label: 'Todos', start: 0},
                        ]}
                        defaultRefinement={'1' === '31' ? '0:' : null}
                        show
                        translations={{
                          All: 'Todos',
                        }}
                      />
                    </ListItem>
                    <ListItem>
                      <AlgoliaCategories
                        className={classes.nested}
                        limit={9999}
                        attributes={['categories.lvl0', 'categories.lvl1', 'categories.lvl2', 'categories.lvl3']}
                      />
                    </ListItem>
                    <ListItem>
                      <AlgoliaBrands attribute="brand.name" limit={9999} />
                    </ListItem>
                  </List>
                </Collapse>
              </List>
              <ClearFilterBottom />
            </Grid>
            <Grid item xs={12} md={9} lg={10}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  {matchCategory?.params?.c_id === '31' ? (
                    <Configure query={queryState} facets={['settlement']} facetFilters={['settlement:true']} />
                  ) : (
                    <Configure
                      key={queryState}
                      query={queryState}
                      facets={[
                        'category_path_ids',
                        'category_path_ids_2',
                        'category_path_ids_3',
                        'category_path_ids_4',
                      ]}
                      facetFilters={[
                        [
                          `category_path_ids:${matchCategory?.params?.c_id || ''}`,
                          `category_path_ids_2:${matchCategory?.params?.c_id || ''}`,
                          `category_path_ids_3:${matchCategory?.params?.c_id || ''}`,
                          `category_path_ids_4:${matchCategory?.params?.c_id || ''}`,
                        ],
                      ]}
                    />
                  )}
                  <ProductList small />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: 30,
                  }}
                >
                  <Pagination />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </InstantSearch>
    </div>
  );
};

export default Search;
